import React from 'react';
import { Routes, Route } from 'react-router-dom';
import styled from 'styled-components';
import Home from './pages/Home';
import Menu from './pages/Menu';
import Order from './pages/Order';
import OrderSuccess from './pages/OrderSuccess';
import OrderCancel from './pages/OrderCancel';
import CartBadge from './components/CartBadge';
import SiteFooter from './components/SiteFooter';
import AdminPage from './pages/Admin'
import Checkout from './pages/Checkout'
import OnlineOrderClosed from './pages/OnlineOrderClosed'

const AppShell = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
`;

const MainContent = styled.main`
  flex: 1;
  display: block;
`;

function App() {
  return (
    <>
      <CartBadge />
      <AppShell>
        <MainContent>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/menu" element={<Menu />} />
            <Route path="/order" element={<Order />} />
            <Route path="/order/success" element={<OrderSuccess />} />
            <Route path="/order/cancel" element={<OrderCancel />} />
            <Route path="/admin" element={<AdminPage />} />
            <Route path="/checkout" element={<Checkout />} />
            <Route path="/technicalerror" element={<OnlineOrderClosed />} />
          </Routes>
        </MainContent>
        <SiteFooter />
      </AppShell>
    </>
  );
}

export default App;
